export const Camera = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 9.8541C3.5 8.83011 4.33011 8 5.3541 8V8C6.05638 8 6.69839 7.60322 7.01246 6.97508L7.83333 5.33333C7.94329 5.11342 7.99827 5.00346 8.06062 4.90782C8.3859 4.40882 8.91668 4.08078 9.50848 4.01299C9.6219 4 9.74484 4 9.99071 4H15.0093C15.2552 4 15.3781 4 15.4915 4.01299C16.0833 4.08078 16.6141 4.40882 16.9394 4.90782C17.0017 5.00346 17.0567 5.11342 17.1667 5.33333L17.9875 6.97508C18.3016 7.60322 18.9436 8 19.6459 8V8C20.6699 8 21.5 8.83011 21.5 9.8541V14.8571C21.5 16.8619 21.5 17.8643 21.0402 18.5961C20.8004 18.9777 20.4777 19.3004 20.0961 19.5402C19.3643 20 18.3619 20 16.3571 20H8.64286C6.6381 20 5.63571 20 4.9039 19.5402C4.52229 19.3004 4.19961 18.9777 3.95983 18.5961C3.5 17.8643 3.5 16.8619 3.5 14.8571V9.8541Z"
        stroke="#33363F"
        strokeWidth="2"
      />
      <circle cx="12.5" cy="13" r="3" stroke="#33363F" strokeWidth="2" />
    </svg>
  );
};
